/* eslint-disable react/prop-types */
import {
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import backArrow from "../../assets/icons/backArrow.svg";
import { useState } from "react";
import ShowInList from "src/sections/events/createEvent/basic-details/ShowInList";
const EventNameHeader = ({ eventData, handleBackEventDetails, getData }) => {

  const [listDialog, setListDialog] = useState(false);



  return (
    <Stack
      sx={{
        justifyContent: "space-between",
        pl: { xs: 1 },
      }}
      spacing={1}
      direction={{ xs: "column", sm: "row" }}
    >
      <Stack direction="row" alignItems="center">
        <IconButton
          onClick={handleBackEventDetails}
          icon={backArrow}
          sx={{ padding: "0px", display: { xs: "none", sm: "block" } }}
        />
        <Typography
          variant="h4"
          color="primary"
          sx={{ fontSize: { xs: "18px", md: "24px" } }}
        >
          {eventData?.name}
        </Typography>
      </Stack>
      {listDialog && (
        <ShowInList
          eventId={eventData?._id}
          open={listDialog}
          handleClose={() => setListDialog(false)}
          eventData={eventData}
          getData={getData}
        />
      )}
    </Stack>
  );
};

export default EventNameHeader;
